import PriceConfig from '@/dto/price_config/PriceConfig'

export default function PriceConfigFactory(): PriceConfig {
  return {
    id: null,
    currencyCode: null,
    pattern: null,
    enabled: true,
  }
}
